import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Avatar, Button, Card, Divider, Empty, Input, Pagination, Segmented, Space, Spin, } from 'antd'
import '../../style/page.css'
import { Edit, LayoutGrid, SearchIcon, } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';

import ModuleAction from '../modules/ModuleAction';
// import AddCategory from './AddCategory';
import { categoryTypes, getCmsData, getCmsDataObject, getCmsTypes } from '../../constant/Constatnt';
import { getCategory, setPagination, setSearchParams } from '../../feature/category/CategorySlice';
import { getPrivacy } from '../../feature/cms/PrivacySlice';
import { getTerms } from '../../feature/cms/TermSlice';
import { getAboutus } from '../../feature/cms/AboutSlice';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

function CmsData() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [types, setTypes] = useState("Privacy Policy")
    const [cmsFor, setCmsFor] = useState("Admin");

    const { privacyList, isLoading: privacyLoading } = useSelector(
        (state) => state.privacies
    );

    const { termsList, isLoading: termsLoading } = useSelector(
        (state) => state.terms
    );

    const { aboutList, isLoading: aboutLoading } = useSelector(
        (state) => state.abouts
    );



    const fetchCmsData = async () => {
        if (types === getCmsDataObject.privacy) {
            dispatch(getPrivacy(cmsFor));
        } else if (types === getCmsDataObject.terms) {
            dispatch(getTerms(cmsFor));
        } else {
            dispatch(getAboutus(cmsFor));

        }
    }

    useEffect(() => {
        fetchCmsData()
    }, [cmsFor, types])



    const cmsTypes = types === getCmsDataObject.privacy ? "privacy-policy" : types === getCmsDataObject.terms ? "terms-conditions" : "about-us"


    const handleEdit = (data) => {
        const id = data === "privacy" ? privacyList?._id : data === "term" ? termsList?._id : aboutList?._id
        navigate(`/dashboard/edit-cms/${cmsFor}/${cmsTypes}/${id}`)
    }
    const fetchData =
        types === getCmsDataObject.privacy ? (
            <Card className='cms_card'>
                <div className="cms_title">
                    <h1>{types}</h1>
                    <p>How we protect your personal information</p>
                </div>

                <div className="update_data">
                    <p>Our {types} has been updated</p>
                    <p>20-08-2025</p>
                </div>

                <Divider orientation="right">{privacyList && <Edit size={24} onClick={() => handleEdit("privacy")} />}</Divider>
                {!privacyList ? <Empty
                    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                    styles={{ image: { height: 60 } }}
                    description={
                        <p>
                            Data no found
                        </p>
                    }
                >
                    <div className="add_modal">
                        <Button onClick={() => navigate(`/dashboard/add-cms/${cmsFor}/${cmsTypes}`)} type="primary">Create Now</Button>
                    </div>
                </Empty> : <div className='cms_data'>
                    {parse(privacyList?.description || "")}
                </div>}

            </Card>
        ) : types === getCmsDataObject.terms ? (
            <Card className='cms_card'>
                <div className="cms_title">
                    <h1>{types}</h1>
                    <p>Legal Information & Notifications</p>
                </div>

                <div className="update_data">
                    <p>Our {types} has been updated</p>
                    <p>20-08-2025</p>
                </div>

                <Divider orientation="right">{termsList && <Edit size={24} onClick={() => handleEdit("term")} />}</Divider>

                {!termsList ?
                    <Empty
                        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                        styles={{ image: { height: 60 } }}
                        description={
                            <p>
                                Data no found
                            </p>
                        }
                    >
                        <div className="add_modal">
                            <Button onClick={() => navigate(`/dashboard/add-cms/${cmsFor}/${cmsTypes}`)} type="primary">Create Now</Button>
                        </div>
                    </Empty> : <div className='cms_data'>
                        {parse(termsList?.description || "")}
                    </div>}
            </Card>
        ) : (
            <Card className='cms_card'>
                <div className="cms_title">
                    <h1>{types}</h1>
                    <p>Know who we are and what we do</p>
                </div>

                <div className="update_data">
                    <p>Our {types} has been updated</p>
                    <p>20-08-2025</p>
                </div>


                <Divider orientation="right">{aboutList && <Edit size={24} onClick={() => handleEdit("about")} />}</Divider>

                {!aboutList ?
                    <Empty
                        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                        styles={{ image: { height: 60 } }}
                        description={
                            <p>
                                Data no found
                            </p>
                        }
                    >
                        <div className="add_modal">
                            <Button onClick={() => navigate(`/dashboard/add-cms/${cmsFor}/${cmsTypes}`)} type="primary">Create Now</Button>
                        </div>
                    </Empty> : <div className='cms_data'>
                        {parse(aboutList?.description || "")}
                    </div>}
            </Card>
        );


    console.log("types----", types)
    return (
        <section>
            <Card>
                <div className="page_title">
                    <p>{Titles.cms}</p>
                    <Segmented
                        block
                        style={{ width: "300px" }}
                        size='large'
                        options={getCmsTypes}
                        onChange={value => {
                            setCmsFor(value)
                        }}
                    />
                </div>
            </Card>
            <div className='cat_types'>
                <Segmented
                    block
                    size='large'
                    options={getCmsData}
                    onChange={value => {
                        setTypes(value)
                    }}
                />
            </div>
            <div className="page_content">
                {(privacyLoading || termsLoading || aboutLoading) ? <Spin  fullscreen /> :
                    <div>
                        {fetchData}
                    </div>
                }
            </div>
        </section >
    )
}


export default CmsData